// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__oMszl","errorLogs":"EditorFooter_errorLogs__3GA8Q"};